import { ReactNode, useRef } from 'react';
import { useResponsive, useSwipeGesture } from '../../hooks';
import { getNavOffset, getSidebarOffset } from '../../utils/designTokens';

interface ResponsiveLayoutProps {
  children: ReactNode;
  onSwipeLeft?: () => void;
  onSwipeRight?: () => void;
  onSwipeUp?: () => void;
  onSwipeDown?: () => void;
}

export const ResponsiveLayout = ({
  children,
  onSwipeLeft,
  onSwipeRight,
  onSwipeUp,
  onSwipeDown
}: ResponsiveLayoutProps) => {
  const { isSmallerThan } = useResponsive();
  const isMobile = isSmallerThan('md');
  const containerRef = useRef<HTMLDivElement>(null);
  
  // Initialize swipe gestures for mobile devices
  useSwipeGesture(
    containerRef as React.RefObject<HTMLElement>,
    {
      onSwipeLeft,
      onSwipeRight,
      onSwipeUp,
      onSwipeDown
    },
    { threshold: 50 }
  );

  // Apply different classes based on device size and orientation
  const getContainerClasses = () => {
    const baseClasses = 'min-h-screen bg-gray-50 overflow-x-hidden';
    // Use standardized spacing system
    const navOffset = getNavOffset(isMobile); // Mobile with nav offset
    const sidebarOffset = getSidebarOffset(isMobile); // Desktop with sidebar offset
    return `${baseClasses} ${navOffset} ${sidebarOffset}`.trim();
  };

  return (
    <div ref={containerRef} className={getContainerClasses()}>
      {children}
    </div>
  );
};

export default ResponsiveLayout; 